module.exports = __webpack_public_path__ + "img/hotel1_2.931f9eab.png";